var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#48BB78"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.06667 13.0667L13.7667 8.36671L12.8333 7.43337L9.06667 11.2L7.16667 9.30004L6.23334 10.2334L9.06667 13.0667ZM10 16.6667C9.07778 16.6667 8.21111 16.4916 7.4 16.1414C6.58889 15.7916 5.88334 15.3167 5.28334 14.7167C4.68334 14.1167 4.20845 13.4112 3.85867 12.6C3.50845 11.7889 3.33334 10.9223 3.33334 10C3.33334 9.07782 3.50845 8.21115 3.85867 7.40004C4.20845 6.58893 4.68334 5.88337 5.28334 5.28337C5.88334 4.68337 6.58889 4.20826 7.4 3.85804C8.21111 3.50826 9.07778 3.33337 10 3.33337C10.9222 3.33337 11.7889 3.50826 12.6 3.85804C13.4111 4.20826 14.1167 4.68337 14.7167 5.28337C15.3167 5.88337 15.7916 6.58893 16.1413 7.40004C16.4916 8.21115 16.6667 9.07782 16.6667 10C16.6667 10.9223 16.4916 11.7889 16.1413 12.6C15.7916 13.4112 15.3167 14.1167 14.7167 14.7167C14.1167 15.3167 13.4111 15.7916 12.6 16.1414C11.7889 16.4916 10.9222 16.6667 10 16.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardCheck);
export default __webpack_public_path__ + "static/media/CardCheck.3ec8752824f511f2c7dac3f0f9b4c8ef.svg";
export { ForwardRef as ReactComponent };